import { cx } from '@emotion/css';

import { useStyles } from './veeva.styles';
import { VeevaProps } from './veeva.models';

export const Veeva = ({
  veevaNumber, isRight, isLeft, backgroundColor, isLeftAbsolute, isRightAbsolute,
}: VeevaProps): JSX.Element => {
  const classes = useStyles();

  return (
    <div
      className={cx(classes.root,
        {
          [classes.right]: isRight,
          [classes.left]: isLeft,
          [classes.isLeftAbsolute]: isLeftAbsolute,
          [classes.isRightAbsolute]: isRightAbsolute,
        })}
      style={{ backgroundColor: backgroundColor }}
    >{veevaNumber}</div>
  );
};
